/**
 * Simplified Chinese translation for the `auth` feature (sign-in, registration,
 * magic-link verification, password reset / set). Keys map 1:1 to the `t('auth.*')`
 * calls in `packages/@gamecodex/world-ui/src/features/auth/*`. Values are the
 * Simplified Chinese translations.
 */
export const authZhCN = {
  // ── AuthShell ────────────────────────────────────────────────────────────
  'auth.shell.homeAriaLabel': 'Grymwyrd 主页',
  'auth.shell.logoAlt': 'Grymwyrd',

  // ── OAuthButtons ─────────────────────────────────────────────────────────
  'auth.oauth.continueWithGoogle': '使用 Google 继续',
  'auth.oauth.continueWithDiscord': '使用 Discord 继续',

  // ── AccountVerifyPage ────────────────────────────────────────────────────
  'auth.verify.seoTitle': '正在登录',
  'auth.verify.seoDescription': '验证您的 Grymwyrd 登录链接。',
  'auth.verify.errorMissingToken':
    '此登录链接缺少令牌。请从登录页面重新申请。',
  'auth.verify.errorInvalidOrExpired':
    '此登录链接无效或已过期。请从登录页面重新申请。',
  'auth.verify.confirming': '确认您的登录中…',
  'auth.verify.signedInHeading': '您已登录',
  'auth.verify.signedInAsPrefix': '登录身份为',
  'auth.verify.signedInAsSuffix': '。为您导入密殿…',
  'auth.verify.takingYouToSanctum': '为您导入密殿…',
  'auth.verify.goNow': '立即前往',
  'auth.verify.problemHeading': '登录链接出现问题',
  'auth.verify.backToSignIn': '返回登录',

  // ── LoginPage ────────────────────────────────────────────────────────────
  'auth.login.errorEnterEmailFirst': '请先输入您的邮箱，然后申请登录链接。',
  'auth.login.seoTitle': '跨越门槛',
  'auth.login.seoDescription': '登录 Grymwyrd，在永恒的暮光中归来。',
  'auth.login.eyebrow': '归来吧，流浪者',
  'auth.login.title': '跨越门槛',
  'auth.login.blurb': '道出你的名字与秘言，重入永恒的暮光。',
  'auth.login.noPactYet': '还未立约？',
  'auth.login.forgeYourLegend': '铸造你的传奇',
  'auth.login.emailLabel': '邮箱',
  'auth.login.emailPlaceholder': 'you@grymwyrd.com',
  'auth.login.passwordLabel': '密码',
  'auth.login.forgotPassword': '忘记密码？',
  'auth.login.submitBusy': '跨越中…',
  'auth.login.submit': '进入',
  'auth.login.dividerOr': '或',
  'auth.login.magicSentPrefix': '登录链接已发送',
  'auth.login.magicSentTo': '至',
  'auth.login.magicSentSuffix': '。请检查收件箱。',
  'auth.login.emailMeSignInLink': '发送登录链接到我的邮箱',
  'auth.login.mockAuthPrefix': '开发模式：任何邮箱都可用。使用',
  'auth.login.mockAuthOr': '或',
  'auth.login.mockAuthSuffix': '获取管理员权限。',

  // ── RegisterPage ─────────────────────────────────────────────────────────
  'auth.register.errorDisplayNameRequired': '选择你的传奇将被讲述的名字。',
  'auth.register.errorEmailRequired': '立约需要一个邮箱。',
  'auth.register.errorEmailInvalid': '该邮箱格式似乎不对。',
  'auth.register.errorPasswordTooShort': '你的秘言至少需要 8 个字符。',
  'auth.register.errorMustBeAdult': '必须年满 13 岁才能加入 Grymwyrd。',
  'auth.register.errorMustAcceptTerms': '必须接受立约（条款）才能继续。',
  'auth.register.errorIncomplete': '立约上的某些印记不完整。请见下方。',
  'auth.register.seoTitle': '开启你的故事',
  'auth.register.seoDescription':
    '创建 Grymwyrd 账户，塑造一位化身，让你的故事成为正史。',
  'auth.register.eyebrow': '探索灰威克村',
  'auth.register.title': '开启你的故事',
  'auth.register.blurb': '你从以太梦境中苏醒，睁开眼睛…',
  'auth.register.alreadyBound': '已经与暮光立约？',
  'auth.register.loginToExisting': '登录到现有账户',
  'auth.register.displayNameLabel': '昵称',
  'auth.register.displayNamePlaceholder': '虚空骑士',
  'auth.register.displayNameHint': '这是你公开的化身名字和贡献署名。',
  'auth.register.emailLabel': '邮箱',
  'auth.register.emailPlaceholder': 'you@grymwyrd.com',
  'auth.register.passwordLabel': '密码',
  'auth.register.passwordPlaceholder': '至少 8 个字符',
  'auth.register.agreementsLegend': '协议',
  'auth.register.adultConfirmPrefix': '我确认我已满',
  'auth.register.adultConfirmEmphasis': '13 周岁',
  'auth.register.adultConfirmSuffix': '。',
  'auth.register.acceptPrefix': '我同意',
  'auth.register.termsOfThePact': '立约条款',
  'auth.register.acceptSuffix': '。',
  'auth.register.submitBusy': '正在封印立约…',
  'auth.register.submit': '踏入',
  'auth.register.dividerOr': '或',
  'auth.register.mockAuthNote': '开发模式：注册仅在本地保存。不会发送邮件。',
  'auth.register.lastUpdated': '最后更新 {date}',

  // ── ResetPasswordPage ────────────────────────────────────────────────────
  'auth.reset.errorInvalidEmail': '输入与你的立约绑定的邮箱。',
  'auth.reset.seoTitle': '重置密码',
  'auth.reset.seoDescription':
    '忘记密码了？我们会发送一条一次性链接；点击它来设置新密码。',
  'auth.reset.eyebrow': '遗失的秘言',
  'auth.reset.title': '重置密码',
  'auth.reset.blurb':
    '低声说出你的邮箱，一条一次性链接将被送入黑暗。跟随它回来，你就可以设置新密码。',
  'auth.reset.rememberedAfterAll': '突然想起来了？',
  'auth.reset.loginToExisting': '登录到现有账户',
  'auth.reset.successMessage':
    '如果存在 {email} 对应的账户，一条一次性链接已被发送。打开它来登录并设置新密码 — 请检查你的邮箱和垃圾邮件文件夹。',
  'auth.reset.sendToDifferentEmail': '发送到另一个邮箱',
  'auth.reset.emailLabel': '邮箱',
  'auth.reset.emailPlaceholder': 'you@grymwyrd.com',
  'auth.reset.submitBusy': '正在召唤…',
  'auth.reset.submit': '发送登录链接',

  // ── SetPasswordPage ──────────────────────────────────────────────────────
  'auth.setPassword.errorTooShort': '密码至少需要 8 个字符。',
  'auth.setPassword.errorMismatch': '两个密码不匹配。',
  'auth.setPassword.seoTitle': '设置密码',
  'auth.setPassword.seoDescription': '为您的 Grymwyrd 账户设置新密码。',
  'auth.setPassword.eyebrow': '封印立约',
  'auth.setPassword.title': '设置新密码',
  'auth.setPassword.blurb':
    '你已登录。设置一个新密码 — 下次你可以将它与魔法链接一起使用。',
  'auth.setPassword.ratherNot': '不想设置？',
  'auth.setPassword.skipForNow': '暂时跳过',
  'auth.setPassword.successMessage': '密码已设置。为您导入密殿…',
  'auth.setPassword.newPasswordLabel': '新密码',
  'auth.setPassword.newPasswordPlaceholder': '至少 8 个字符',
  'auth.setPassword.confirmPasswordLabel': '确认密码',
  'auth.setPassword.confirmPasswordPlaceholder': '再输入一次',
  'auth.setPassword.submitBusy': '正在封印…',
  'auth.setPassword.submit': '保存密码',
} as const
